/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import { message, Row, Col, Divider } from 'antd';
import { Popconfirm } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';

class ServerFile extends React.Component {
  printFilePath = () => {
    this.props.transferServerFile(this.props.filePath);
  };
  confirm = e => {
    this.props.saveServerFile(this.props.filePath);
  };
  cancel = e => {
    const { t } = this.props;
    message.error(t('label_clickOnNo'));
  };
  render() {
    const { t } = this.props;
    return (
      <div>
        {this.props.localFileCopied && this.props.type === 'Folder' ? (
          <Popconfirm
            title={t('copy_confirmTxt')}
            onConfirm={this.confirm}
            onCancel={this.cancel}
            okText={t('label_yes')}
            cancelText={t('label_no')}
          >
            <Row>
              <Col span={10}>{this.props.title}</Col>
              <Col span={6}>{this.props.size}</Col>
              <Col span={6} style={{ justifyContent: 'center' }}>
                <p>{t('label_noAction')}</p>
              </Col>
            </Row>
            <Divider />
          </Popconfirm>
        ) : (
          <>
            <Row>
              <Col span={10}>{this.props.title}</Col>
              <Col span={8}>{this.props.size}</Col>
              <Col span={6} style={{ justifyContent: 'center' }}>
                {this.props.type === 'Folder' ? (
                  <p>{t('label_noAction')}</p>
                ) : (
                  <CopyOutlined
                    onClick={() => {
                      this.printFilePath();
                    }}
                  />
                )}
              </Col>
            </Row>
            <Divider />
          </>
        )}
      </div>
    );
  }
}

export default withTranslation()(ServerFile);
